import { StateService } from '@uirouter/core';
import angular, { IQService } from 'angular';
import { CartService } from '../../../tn.cart/service.tn.cart';
import {
    FontListParams,
    FontListParamsStateParamsResolver,
    FontStyleService,
    FontVisibility,
    FontWeight,
    FontWidth,
    IFontFamilyModel,
    IFontStyleModel,
    SortOption,
} from '../../../tn.common';
import { PopoverService } from '../../../tn.popover/service.tn.popover';
import { UserService } from '../../../tn.user/service.tn.user';

import { StateParams, Transition, TransitionService } from 'angular-ui-router';
import template from './family-page.html';

export class FamilyPageController {
    // bindings
    filters: FontListParams = {};
    family?: IFontFamilyModel;

    // locals
    customText = '';
    disableWeightSort = false;
    disableWidthSort = false;
    disableSizeSort = false;
    filteredStyles: IFontStyleModel[] = [];
    loaded = false;
    size = 100;
    sizeMin = 50;
    sizeMax = 150;
    sizeStep = 1;
    sortOptions = {
        size: new SortOption('size', false),
        weight: new SortOption('weight', false),
        width: new SortOption('width', true),
    };
    styles: IFontStyleModel[] = [];

    buyPopover = this.$tnPopover.popoverXS(
        angular.element('.popover-styles-add')
    );

    static $inject = [
        '$q',
        '$state',
        '$stateParams',
        '$tnPopover',
        '$transitions',
        'tn.cart.service',
        'tn.user.service',
        'FontStylePublicService',
    ];
    constructor(
        protected $q: IQService,
        protected $state: StateService,
        protected $stateParams: StateParams,
        protected $tnPopover: PopoverService,
        protected $transitions: TransitionService,
        protected cartService: CartService,
        userService: UserService,
        protected styleService: FontStyleService
    ) {
        userService.logout$.subscribe(() => {
            if (this.family?.visible == FontVisibility.EVERYONE) {
                return;
            }
            if (this.family?.visible == FontVisibility.WITH_LINK) {
                return;
            }
            // if the family is no longer visible, go home.
            // TODO: is there a better pattern for handling redirects on auth state changes?
            $state.go('home.fonts.listing');
        });

        const onTransitionSuccess = (transition: Transition) => {
            const params = transition.params();
            this.onStateParamsChanged(params);
        };

        // the filters parameters are all dynamic to avoid rendering the entire
        // ui. since resolvers are not ran on dynamic transitions, catch the onSuccess
        // and update the filters.
        // we only catch transitions to the same state, since initial state loads should be
        $transitions.onSuccess(
            {
                to: 'home.foundry.fonts.styles',
                from: 'home.foundry.fonts.styles',
            },
            onTransitionSuccess
        );
    }

    $onInit(): void {
        const family = this.family;
        if (!family) {
            this.styles = [];
            this.onStateParamsChanged(this.$stateParams);
            this.loaded = true;
            return;
        }
        this.styleService
            .list({ family: [family.id], page_size: 10000 })
            .then(({ results: styles }) => {
                this.styles = styles;
            })
            .finally(() => {
                this.onStateParamsChanged(this.$stateParams);
                this.loaded = true;
            });
    }

    onStateParamsChanged(params: Partial<StateParams>): void {
        const filters = FontListParamsStateParamsResolver(params);
        this.filters = filters;
        this.$tnPopover.hide();
        this.onFiltersChanged();
    }

    onFamilyChanged(): void {
        this.loaded = false;
    }

    onFiltersChanged(): void {
        this.filteredStyles = this.styles.filter((style) => this.filter(style));
        const distinctSortOptions = this.filteredStyles.reduce(
            (acc, style) => {
                style.tn_size.forEach((s) => acc.sizes.add(s));
                style.weight && acc.weights.add(style.weight);
                style.width && acc.widths.add(style.width);
                return acc;
            },
            {
                sizes: new Set<number>(),
                widths: new Set<FontWidth>(),
                weights: new Set<FontWeight>(),
            }
        );

        this.disableSizeSort = distinctSortOptions.sizes.size <= 1;
        this.disableWeightSort = distinctSortOptions.weights.size <= 1;
        this.disableWidthSort = distinctSortOptions.widths.size <= 1;
    }

    filter(style: IFontStyleModel): boolean {
        return (
            // weight check
            (this.filters.weight === undefined ||
                this.filters.weight.length === 0 ||
                this.filters.weight.includes(style.weight)) &&
            // width check
            (this.filters.width === undefined ||
                this.filters.width.length === 0 ||
                this.filters.width.includes(style.width)) &&
            // posture check
            (this.filters.posture === undefined ||
                this.filters.posture.length === 0 ||
                this.filters.posture.includes(style.posture))
        );
    }
}

export const FamilyPageComponent = {
    bindings: {
        filters: '<',
        family: '<',
    },
    controller: FamilyPageController,
    controllerAs: 'vm',
    template,
};
